import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ExportService } from '../shared/services/exportservice';
import { CommonService } from '../shared/services/common.service';
import { ApiService } from '../shared/services/api.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatModule } from '../appModules/mat.module';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-college-data',
  imports: [ReactiveFormsModule, MatInput, MatModule, MatSelectModule, MatFormFieldModule, MatInputModule, CommonModule],
  templateUrl: './college-data.component.html',
  styleUrl: './college-data.component.scss'
})
export class CollegeDataComponent {
dataSource: any = new MatTableDataSource([]);
  displayedColumns: any = {
   label: ['sno','name','state','Nationality','GRADUATION_LEVEL','is_active','createdAt'],
   cols:  ['sno','name','state','Nationality','GRADUATION_LEVEL','is_active','createdAt'],
  }
  pagination = {
    length: 0,
    page: 1,
    limit: 5,
  };
  currentPage=0;
 //currentindex=1;
 formGroup: FormGroup;
 isLoading = false;

 CollegeId: string | null = null;
 
 isCollegeList=true;

 constructor(
   private fb: FormBuilder,
   private api: ApiService,
   private common: CommonService,
 ) {
   this.formGroup = this.fb.group({
    name: ['', [Validators.required]],
    state: ['', [Validators.required]],
    Nationality: ['', [Validators.required]],
    GRADUATION_LEVEL: ['', [Validators.required]],
   });
 }

 ngOnInit(): void {
  
   this.getCollegeList();
 }



 getCollegeList(): void {
   this.isCollegeList=true;
   this.isLoading = true;

   const queryParam: any = [];
   queryParam.push(`page=${this.pagination.page}`, `limit=${this.pagination.limit}`);
   this.api.get(`settings/getCollegeList?${queryParam.join('&')}`).subscribe({
     next: (response) => {
     
       if (response && response.data && response.data.length > 0) {

         this.dataSource = response.data;
         this.pagination.length = response?.totalCount || 0;
       } else {
         console.log('No settings found or empty settings array');
       }
       this.isLoading = false;
     },
     error: (error) => {
       console.error('Error fetching settings information:', error);
       this.common.notification('Error loading settings information', true);
       this.isLoading = false;
     }
   });
 }
 
 resetForm(): void {
   this.isCollegeList=false;
   this.formGroup.reset();
  
 }


isEdit=false;
 edit(row:any){
   this.isCollegeList=false;   
   this.CollegeId=row.id;
   this.isEdit=true;
   this.formGroup.patchValue({
    name: row.name,
    state: row.state,
    Nationality: row.Nationality,
    GRADUATION_LEVEL: row.GRADUATION_LEVEL,
   });
 }
   


 saveCollege(): void {
   this.isCollegeList=false;
   if (this.formGroup.invalid) {
    this.common.notification('Please fill all required information', true);
     return;
   }

   this.isLoading = true; 
   let formData =  this.formGroup.value;
   if (this.CollegeId) {
        
     this.api.put(`settings/updateCollege/${this.CollegeId}`, formData).subscribe({
       next: (response) => {
         
         this.common.notification(response.message);
         this.isLoading = false;
       },
       error: (error) => {
         console.error('Error updating settings information. Full error:', error);
         this.isLoading = false;
       }
       
     });
     this.resetForm();
   } else {
    this.api.post(`settings/addCollege`,formData,true).subscribe({
       next: (response) => {
        if (response.status) {
           this.common.notification(response.message);
           this.isLoading = false;
         }else{
         this.common.notification(response.message);
        }
         this.isLoading = false;
       },
       error: (error) => {
         this.common.notification(`Error saving razorpay: ${error.message || 'Unknown error'}`, true);
         this.isLoading = false;
       }
     });
     this.getCollegeList();
     this.resetForm();
   }
 }
 



 addCollege(){
   this.isLoading=false;
   this.resetForm();
   this.isCollegeList=false;
 }
 


back(){
 this.isEdit=false;
 this.isCollegeList=true;  
 this.resetForm();
 this.CollegeId=null;
 this.getCollegeList();
}

delete(row:any)
{

 const collegeId=row.id;
 this.api.put(`settings/deleteCollege/${collegeId}`,'').subscribe((resp:any)=>{
   if(resp.status){
     this.common.notification(resp.message);
   }else{
     this.common.notification("unable to delete");
   }
   this.getCollegeList();

 });
}

pageEvent(e: any) {
  this.isLoading = false;
 
  this.pagination.page = e.pageIndex + 1;
  this.pagination.limit = e.pageSize;
  this.currentPage = e.pageIndex * e.pageSize;
  this.getCollegeList();
}

}
